module.exports = __webpack_public_path__ + "img/food-10.cb0ea4b1.jpg";